import { Reveal, SectionHead } from "@/lib/motion";

const CONTENT = {
  privacy: {
    overline: "Privacy Policy",
    title: "Your information is yours.",
    sections: [
      { h: "What we collect", ps: ["Only what is needed to prepare your return or respond to your enquiry: contact details, tax documents you choose to share, and the information on them. Website enquiries collect name, email, phone (optional) and your message."] },
      { h: "How it is used", ps: ["To provide tax preparation and accounting services, respond to enquiries, and meet legal obligations. We do not sell or rent your information, and we do not use it for marketing beyond what you ask us for."] },
      { h: "How long it is kept", ps: ["Tax records are retained as required by professional standards and law. Enquiry data from non-clients is retained only as long as needed to respond and for reasonable follow-up."] },
      { h: "Your choices", ps: ["Ask any time what we hold about you, request corrections, or ask us to delete enquiry data. Contact us through the form on this site."] },
    ],
  },
  terms: {
    overline: "Terms of Use",
    title: "Plain terms, plainly stated.",
    sections: [
      { h: "General information only", ps: ["Content on this site — including articles, FAQs and the Complexity Check — is general information, not tax, legal or accounting advice for your specific situation. Engagement begins only with a signed agreement."] },
      { h: "Estimates", ps: ["The Complexity Check provides an indicative read, not a binding quote. Final fees are confirmed in writing before work begins."] },
      { h: "Accuracy", ps: ["We work to keep information current, but tax law changes. Where this site and current law differ, the law wins."] },
      { h: "Acceptable use", ps: ["Do not upload or transmit sensitive personal information through general contact forms. Sensitive documents belong in the secure client portal."] },
    ],
  },
  security: {
    overline: "Data Security",
    title: "How taxpayer data is protected here.",
    sections: [
      { h: "Secure document portal", ps: ["Sensitive tax documents are transmitted through a secure client portal rather than ordinary email. If you are ever asked to email a W-2 or Social Security number, stop and call us — that request did not come from us."] },
      { h: "Multi-factor authentication", ps: ["Accounts containing sensitive information are protected using MFA where available, adding a second barrier beyond a password."] },
      { h: "Controlled access", ps: ["Client information is accessible only when necessary to provide services. Access is limited, deliberate, and reviewed."] },
      { h: "Written Information Security Plan", ps: ["Steele Industries maintains written procedures designed to protect taxpayer information — the WISP the IRS requires of tax professionals — covering safeguards such as MFA, firewalls, backups and encryption."] },
    ],
  },
};

export default function Legal({ kind }) {
  const page = CONTENT[kind] || CONTENT.privacy;
  return (
    <div data-testid={`legal-${kind}-page`} className="pt-20">
      <section className="border-b border-steel-border">
        <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
          <SectionHead overline={page.overline} title={page.title} />
        </div>
      </section>
      <section className="mx-auto max-w-3xl px-6 py-20 lg:px-10">
        {page.sections.map((s, i) => (
          <Reveal key={s.h} delay={i * 0.05}>
            <div className="border-b border-steel-border/70 py-10">
              <h2 className="font-display text-2xl font-medium text-steel-text">{s.h}</h2>
              {s.ps.map((p, j) => (
                <p key={j} className="mt-4 text-base leading-relaxed text-steel-secondary">{p}</p>
              ))}
            </div>
          </Reveal>
        ))}
      </section>
    </div>
  );
}
